import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontSize, fontWeight, lineHeight, getSpacing } from 'stylesheetB2b';


export const EmptyListMessageTitle = styled.h3`
  text-align: center;
  font-size: ${fontSize.mediumLarge};
  font-weight: ${fontWeight.bold};
  margin-bottom: ${getSpacing(1)};
`;

export const EmptyListMessage = styled.p<{ colors: ColormapInterface }>`
  text-align: center;
  font-size: ${fontSize.extraSmall};
  font-weight: ${fontWeight.light};
  line-height: ${lineHeight.small};
  color: ${({ colors }) => colors.lastSongEmptyMessage};
  margin: 0 15px;
`;
EmptyListMessage.displayName = 'EmptyListMessage';

export const EmptyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${getSpacing(18)};
`;
